<template>
<div :class="cls" class="alert top-alert d-flex align-items-top justify-content-between gap-3">
    <div v-html="html"></div>
    <i class="ion-close-round" title="close" @click="hide_alert()"></i>
</div>
</template>
<script>

// How long the alert is visible if not set to stay indefinitely
const ALERT_VISIBLE_MS = 5000

import { bus, events } from '@/helpers/event_bus.js'

export default {
    props: ["alert"],

    data(){
        return {
            visible: false, // Whether the alert should be visible
            offcanvas: true, // Whether the alert is outside of the viewport
            type: null, // Alert type (success, danger, warning)
            html: "" // Contents (html)
        }
    },

    computed: {
        cls(){ 
            // Dynamic alert classes
            let c = {
                'visible': this.visible,
                'wide': this.html.length > 100
            }
            const type = this.type || "success"
            c[`alert-${type}`] = true
            return c
        }
    },

    created(){
        // Register event handlers for the 3 kinds of alerts
        bus.$on(events.ERROR, (msg, sticky) => this.show_alert('danger', msg, sticky))
        bus.$on(events.SUCCESS, (msg, sticky) => this.show_alert('success', msg, sticky))
        bus.$on(events.INFO, (msg, sticky) => this.show_alert('info', msg, sticky))
        bus.$on(events.WARNING, (msg, sticky) => this.show_alert('warning', msg, sticky))
    },

    methods: {

        async show_alert(type, html, is_sticky) {

            if(!this.offcanvas){
                // A previous alert is still visible, close it and wait until it's gone
                await this.hide_alert()
            }

            // Show the correct alert type and given contents
            this.type = type
            this.visible = true
            this.offcanvas = false
            this.html = html

            if(!is_sticky){
                // Schedule hiding
                setTimeout(this.hide_alert, ALERT_VISIBLE_MS)
            }
        },

        hide_alert() {
            // Hides the alert, returns a promise that resolves when the div disappeared.
            this.visible = false // Trigger animation that slides the div up
            var self = this
            return new Promise((resolve) => {
                setTimeout(() => {
                    self.html = ""
                    self.offcanvas = true
                    resolve()
                }, 200) // same delay as the CSS transition time
            })
        },
    },
}
</script>
<style scoped>
    .top-alert{
        position: fixed;
        top: -100px;
        min-height: 60px;
        min-width: 100px;
        padding: 1em;
        right: 10px;
        margin: 0px;
        border-radius: 3px;
        transition: 200ms top ease-in-out;
        opacity: .95;
        z-index: 9999
    }
    .top-alert.visible{
        top: 10px
    }

    .top-alert.wide{
        max-width: 80%;
    }
    .top-alert i{
        cursor: pointer;
    }

</style>
